export default "__VITE_ASSET__CpYEFz1J__"